"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UShapedLayout = exports.TheatreLayout = exports.StandingLayout = exports.SeatingLayout = exports.NotSureLayout = exports.DinnerRoundsLayout = exports.ClassroomLayout = exports.CabaretLayout = exports.BoardroomLayout = void 0;

var _react = _interopRequireDefault(require("react"));

var _colours = require("../colours");

var defaultWidth = "100%";
var defaultColour = _colours.grey[800];

var BoardroomLayout = function BoardroomLayout(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? defaultWidth : _ref$width,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? defaultColour : _ref$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Boardroom Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M6 26a4 4 0 110 8 4 4 0 010-8M54 26a4 4 0 110 8 4 4 0 010-8M42 42.072a4 4 0 110 8 4 4 0 010-8M29.992 42.072a4 4 0 110 8 4 4 0 010-8M18.003 42.072a4 4 0 110 8 4 4 0 010-8M42 10a4 4 0 110 8 4 4 0 010-8M29.992 10a4 4 0 110 8 4 4 0 010-8M18.003 10a4 4 0 110 8 4 4 0 010-8M15.003 39.084h30a2 2 0 002-2v-14a2 2 0 00-2-2h-30a2 2 0 00-2 2v14a2 2 0 002 2z"
  }));
};

exports.BoardroomLayout = BoardroomLayout;

var CabaretLayout = function CabaretLayout(_ref2) {
  var _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? defaultWidth : _ref2$width,
      _ref2$fill = _ref2.fill,
      fill = _ref2$fill === void 0 ? defaultColour : _ref2$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Cabaret Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M25.16 10.874a4 4 0 11-7.25 3.381 4 4 0 017.25-3.38M6.54 40.286a4 4 0 113.38 7.251 4 4 0 01-3.38-7.25M51.191 22.245a4 4 0 113.381 7.251 4 4 0 01-3.38-7.25M9.758 21.724a4 4 0 11-2.736 7.518 4 4 0 012.736-7.518M54.089 40.54a4 4 0 11-2.737 7.519 4 4 0 012.737-7.518M36.205 11.358a4 4 0 117.518 2.737 4 4 0 01-7.518-2.737M31.024 52.195c-4.54 0-8.81-1.769-12.02-4.98a16.89 16.89 0 01-4.98-12.02 16.885 16.885 0 014.98-12.02 16.89 16.89 0 0112.02-4.98c4.54 0 8.81 1.769 12.02 4.98a16.89 16.89 0 014.98 12.02c0 4.54-1.768 8.81-4.98 12.02a16.89 16.89 0 01-12.02 4.98"
  }));
};

exports.CabaretLayout = CabaretLayout;

var ClassroomLayout = function ClassroomLayout(_ref3) {
  var _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? defaultWidth : _ref3$width,
      _ref3$fill = _ref3.fill,
      fill = _ref3$fill === void 0 ? defaultColour : _ref3$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Classroom Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M9 38.3787h41.996c1.1045695 0 2-.8954305 2-2v-2.012c0-1.1045695-.8954305-2-2-2H9c-1.1045695 0-2 .8954305-2 2v2.012c0 1.1045695.8954305 2 2 2zM9 14.0127h41.996c1.1045695 0 2-.8954305 2-2v-2.012c0-1.1045695-.8954305-2-2-2H9c-1.1045695 0-2 .8954305-2 2v2.012c0 1.1045695.8954305 2 2 2zM14.8245 20.52c1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657 1.562-1.562 4.095-1.562 5.657 0M45.1755 20.5208c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M33.1676 20.5208c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M21.1676 20.5208c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M14.8245 44.5204c1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657 1.562-1.562 4.095-1.562 5.657 0M45.1755 44.5213c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M33.1676 44.5213c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M21.1676 44.5213c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657"
  }));
};

exports.ClassroomLayout = ClassroomLayout;

var DinnerRoundsLayout = function DinnerRoundsLayout(_ref4) {
  var _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? defaultWidth : _ref4$width,
      _ref4$fill = _ref4.fill,
      fill = _ref4$fill === void 0 ? defaultColour : _ref4$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Dinner Rounds Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M34.0794 6c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4 4 1.791 4 4M34.0794 54.1588c0 2.209-1.791 4-4 4s-4-1.791-4-4 1.791-4 4-4 4 1.791 4 4M6 26.0794c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M54.1588 26.0794c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M15.8811 10.2242c1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657 1.562-1.562 4.095-1.562 5.657 0M49.9345 44.2777c1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657 1.562-1.562 4.095-1.562 5.657 0M10.2243 44.2776c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M44.2777 10.2242c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M30.0242987 47.1954c-4.5401455 0-8.8098056-1.7691741-12.020566-4.9799346s-4.9789335-7.4804207-4.9789335-12.0205663c-.001001-4.5401456 1.7681731-8.8098058 4.9789335-12.0205663 3.2107604-3.2107605 7.4804205-4.9789328 12.020566-4.9789328 4.5401454 0 8.8098056 1.7681723 12.020566 4.9789328s4.9799345 7.4804207 4.9799345 12.0205663c0 4.5401456-1.7691741 8.8098058-4.9799345 12.0205663-3.2107604 3.2107605-7.4804206 4.9799346-12.020566 4.9799346"
  }));
};

exports.DinnerRoundsLayout = DinnerRoundsLayout;

var NotSureLayout = function NotSureLayout(_ref5) {
  var _ref5$width = _ref5.width,
      width = _ref5$width === void 0 ? defaultWidth : _ref5$width,
      _ref5$fill = _ref5.fill,
      fill = _ref5$fill === void 0 ? defaultColour : _ref5$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Not Sure Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M25.2684873 50.2516364c0-2.7607273 1.9570909-4.7178182 4.5665454-4.7178182 2.6189091 0 4.576 1.9570909 4.576 4.7178182 0 2.8269091-1.9570909 4.8596363-4.576 4.8596363-2.6094545 0-4.5665454-2.0327272-4.5665454-4.8596363M29.3339418 11.10981818c-4.72727271 0-7.5541818 2.46763637-7.77163635 7.41236362l-6.5330909-.0756363C15.3128509 9.22836364 21.05176 4 30.0524873 4c8.7170909 0 14.5221818 4.20727273 14.5221818 12.1207273 0 11.4778182-11.4683636 11.9789091-11.4683636 21.7832727h-6.3912728c0-11.6858182 10.0974546-11.7614545 10.0974546-20.5447273 0-4.21672725-2.9781818-6.24945452-7.4785455-6.24945452"
  }));
};

exports.NotSureLayout = NotSureLayout;

var SeatingLayout = function SeatingLayout(_ref6) {
  var _ref6$width = _ref6.width,
      width = _ref6$width === void 0 ? defaultWidth : _ref6$width,
      _ref6$fill = _ref6.fill,
      fill = _ref6$fill === void 0 ? defaultColour : _ref6$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Seating Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M46.987 33c1.1045695 0 2 .8954305 2 2v4c0 1.1045695-.8954305 2-2 2H45.04l.001 17.057h-3.937L41.103 41H19.081l.001 17h-4.07l-.001-17H13c-1.0543618 0-1.91816512-.8158778-1.99451426-1.8507377L11 39v-4c0-1.1045695.8954305-2 2-2zM17 2h26.25c1.0543618 0 1.9181651.8158778 1.9945143 1.85073766L45.25 4v28h-6v-8.2583488h-18V32H15V4c0-1.0543618.81587779-1.91816512 1.85073766-1.99451426L17 2h26.25z"
  }));
};

exports.SeatingLayout = SeatingLayout;

var StandingLayout = function StandingLayout(_ref7) {
  var _ref7$width = _ref7.width,
      width = _ref7$width === void 0 ? defaultWidth : _ref7$width,
      _ref7$fill = _ref7.fill,
      fill = _ref7$fill === void 0 ? defaultColour : _ref7$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Seating Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M30.047 19.9546c4.994 0 9.042 4.048 9.042 9.042l-.102 10.21c-.013.451-.382.813-.833.813h-3.168l.001.092v15.042c-.014.451-.383.813-.834.813l-1.999.001h-3.167l-1.112-.032-1.999-.001c-.452 0-.821-.362-.834-.813v-15.134l-3.208.032c-.451 0-.82-.362-.834-.813l.005-10.21c0-4.994 4.049-9.042 9.042-9.042zm-16.20144569.0449c2.39213279 0 4.56277309.9435731 6.15513189 2.4766079-.7723691 1.3053876-1.2389692 2.827286-1.2977498 4.4578086l-.0063165.351021L18.794 39.4695l-.0521839-.0005029v14.7082998c-.0127175.4383139-.3737007.7901313-.8158806.7901313l-1.9545916.0009719-1.08881905.0310999-5.05376395-.0009719c-.44120161 0-.80218475-.3518174-.81588059-.7901313V39.5895092l.00097828-.0894122H5.91566455c-.4421799 0-.80316303-.3518174-.8158806-.7901313L5 28.78716c0-4.8535251 3.96005351-8.78766 8.84555431-8.78766zm32.07005179-.0449c4.8021774 0 8.7109352 3.7948846 8.8490024 8.5285464l.0037741.2591136-.0998654 9.9228057c-.0116673.4017877-.3162133.7308944-.707005.7829553l-.1085627.007176h-3.1017027l.0009791.0894122v14.6188876c-.0125648.4017878-.3171856.7308944-.7079836.7829553l-.1085632.007176-1.9571665.0009719h-3.1007237l-1.088729-.0310999-1.9571666-.0009719c-.4056625 0-.7430415-.2956243-.8062579-.6825084l-.0102888-.1076229.0007167-14.1944373c.0184427-.0544446.0317932-.1114101.0394449-.1702633l.0071276-.0896165-.0048954-12.4526166c0-1.760179-.4712976-3.4053929-1.2892765-4.80566 1.5912445-1.5262283 3.7588969-2.4652032 6.1471422-2.4652032zM14.0076 8.022c2.76 0 5.006 2.246 5.006 5.007 0 2.76-2.246 5.006-5.006 5.006-2.761 0-5.006-2.246-5.006-5.006 0-2.761 2.245-5.007 5.006-5.007zm31.0743 0c2.761 0 5.007 2.246 5.007 5.007 0 2.76-2.246 5.006-5.007 5.006-2.76 0-5.006-2.246-5.006-5.006 0-2.761 2.246-5.007 5.006-5.007zM30.0428 4c2.756 0 4.998 2.242 4.998 4.998 0 2.756-2.242 4.998-4.998 4.998-2.756 0-4.998-2.242-4.998-4.998 0-2.756 2.242-4.998 4.998-4.998z"
  }));
};

exports.StandingLayout = StandingLayout;

var TheatreLayout = function TheatreLayout(_ref8) {
  var _ref8$width = _ref8.width,
      width = _ref8$width === void 0 ? defaultWidth : _ref8$width,
      _ref8$fill = _ref8.fill,
      fill = _ref8$fill === void 0 ? defaultColour : _ref8$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Theatre Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M14.8285 13.3303c1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657 1.562-1.562 4.095-1.562 5.657 0M14.8285 25.3303c1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657 1.562-1.562 4.095-1.562 5.657 0M14.8285 37.3366c1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657 1.562-1.562 4.095-1.562 5.657 0M14.8285 49.3307c1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657 1.562-1.562 4.095-1.562 5.657 0M45.1795 49.3316c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M33.1717 49.3316c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M21.1717 49.3316c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M45.1795 13.3311c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M33.1717 13.3311c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M21.1717 13.3311c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M45.1795 25.3311c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M33.1717 25.3311c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M21.1717 25.3311c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M45.1795 37.3375c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M33.1717 37.3375c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M21.1717 37.3375c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657-1.562 1.562-4.095 1.562-5.657 0-1.562-1.562-1.562-4.095 0-5.657M12.0041 8.165h35.996c1.1045695 0 2-.8954305 2-2V6c0-1.1045695-.8954305-2-2-2h-35.996c-1.1045695 0-2 .8954305-2 2v.165c0 1.1045695.8954305 2 2 2z"
  }));
};

exports.TheatreLayout = TheatreLayout;

var UShapedLayout = function UShapedLayout(_ref9) {
  var _ref9$width = _ref9.width,
      width = _ref9$width === void 0 ? defaultWidth : _ref9$width,
      _ref9$fill = _ref9.fill,
      fill = _ref9$fill === void 0 ? defaultColour : _ref9$fill;
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: width,
    title: "Theatre Layout"
  }, _react["default"].createElement("path", {
    fill: fill,
    d: "M6 26c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M54 26c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M6 38c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M54 38c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M42 10c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M30 10c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M18 10c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4M15 49.1h30c1.1045695 0 2-.8954305 2-2v-24c0-1.1045695-.8954305-2-2-2H15c-1.1045695 0-2 .8954305-2 2v24c0 1.1045695.8954305 2 2 2z"
  }));
}; // export const DinnerRoundsLayout = ({
//   width = defaultWidth,
//   fill = defaultColour
// }) => (
//   <svg
//     title={"Dinner rounds layout"}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 64 64"
//     width={width}
//     fill={fill}
//   >
//     <g fill="#2C2E2C" fill-rule="nonzero">
//       <path d="M34.08 6a4 4 0 11-8.001 0 4 4 0 018 0M34.08 54.159a4 4 0 11-8.001 0 4 4 0 018 0M6 26.08a4 4 0 110 8 4 4 0 010-8M54.159 26.08a4 4 0 110 8 4 4 0 010-8M15.881 10.224a4 4 0 11-5.658 5.657 4 4 0 015.658-5.657M49.934 44.278a4 4 0 11-5.657 5.657 4 4 0 015.657-5.657M10.224 44.278a4 4 0 115.657 5.657 4 4 0 01-5.657-5.657M44.278 10.224a4 4 0 115.657 5.658 4 4 0 01-5.657-5.658M30.024 47.195c-4.54 0-8.81-1.769-12.02-4.98a16.89 16.89 0 01-4.98-12.02 16.885 16.885 0 014.98-12.02 16.89 16.89 0 0112.02-4.98c4.54 0 8.81 1.769 12.02 4.98a16.89 16.89 0 014.98 12.02c0 4.54-1.768 8.81-4.98 12.02a16.89 16.89 0 01-12.02 4.98" />
//     </g>
//   </svg>
// );
// export const NotSureLayout = ({ width = defaultWidth }) => (
//   <svg
//     title={"Not Sure which Layout"}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 64 64"
//     width={width}
//   >
//     <g fill="#2C2E2C" fill-rule="nonzero">
//       <path d="M25.268 50.252c0-2.761 1.958-4.718 4.567-4.718 2.619 0 4.576 1.957 4.576 4.718 0 2.827-1.957 4.86-4.576 4.86-2.61 0-4.567-2.033-4.567-4.86M29.334 11.11c-4.727 0-7.554 2.467-7.772 7.412l-6.533-.075C15.313 9.228 21.052 4 30.052 4c8.718 0 14.523 4.207 14.523 12.12 0 11.479-11.469 11.98-11.469 21.784h-6.391c0-11.686 10.097-11.761 10.097-20.545 0-4.216-2.978-6.25-7.478-6.25" />
//     </g>
//   </svg>
// );
// export const StandingLayout = ({
//   width = defaultWidth,
//   fill = defaultColour
// }) => (
//   <svg
//     title={"Standing Layout"}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 64 64"
//     width={width}
//     fill={fill}
//   >
//     <path
//       d="M30.047 19.955a9.042 9.042 0 019.042 9.042l-.102 10.21a.836.836 0 01-.833.813h-3.168l.001.092v15.042a.838.838 0 01-.834.813h-5.166l-1.112-.031-1.999-.001a.836.836 0 01-.834-.813V39.988l-3.208.032a.838.838 0 01-.834-.813l.005-10.21a9.042 9.042 0 019.042-9.042zM13.846 20c2.392 0 4.562.943 6.155 2.476a9.402 9.402 0 00-1.298 4.458l-.006.35.097 12.185h-.052v14.708a.816.816 0 01-.816.79l-1.955.001-1.088.031H9.829a.817.817 0 01-.816-.79V39.5H5.917a.816.816 0 01-.816-.79L5 28.787C5 23.934 8.96 20 13.846 20zm32.07-.045c4.802 0 8.71 3.794 8.849 8.528l.003.26-.1 9.922a.816.816 0 01-.706.783l-.11.007h-3.1v14.708a.818.818 0 01-.708.783l-.108.008h-5.058l-1.089-.03-1.957-.001a.817.817 0 01-.806-.683l-.01-.108V39.938a.887.887 0 00.04-.17l.007-.09-.005-12.453c0-1.76-.472-3.405-1.29-4.805a8.853 8.853 0 016.148-2.465zM14.008 8.022a5.012 5.012 0 015.006 5.007 5.012 5.012 0 01-5.006 5.006 5.011 5.011 0 01-5.006-5.006 5.012 5.012 0 015.006-5.007zm31.074 0a5.013 5.013 0 015.007 5.007 5.012 5.012 0 01-5.007 5.006 5.012 5.012 0 01-5.006-5.006 5.012 5.012 0 015.006-5.007zM30.042 4a5.004 5.004 0 014.999 4.998 5.004 5.004 0 01-4.998 4.998 5.004 5.004 0 01-4.998-4.998A5.004 5.004 0 0130.043 4z"
//       fill="#2C2E2C"
//       fill-rule="nonzero"
//     />
//   </svg>
// );
// export const TheaterLayout = ({
//   width = defaultWidth,
//   fill = defaultColour
// }) => (
//   <svg
//     title={"Theater Style Layout"}
//     width={width}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 64 64"
//     fill={fill}
//     xlink="http://www.w3.org/1999/xlink"
//   >
//     <defs>
//       <path id="a" d="M.004 0h8v8h-8z" />
//       <path id="c" d="M.996 0h8v8h-8z" />
//       <path id="e" d="M.996 0h8v8h-8z" />
//     </defs>
//     <g fill="none" fill-rule="evenodd">
//       <path
//         d="M9 38.379h41.996a2 2 0 002-2v-2.012a2 2 0 00-2-2H9a2 2 0 00-2 2v2.012a2 2 0 002 2zM9 14.013h41.996a2 2 0 002-2V10a2 2 0 00-2-2H9a2 2 0 00-2 2v2.012a2 2 0 002 2zM14.825 20.52a4 4 0 11-5.658 5.657 4 4 0 015.658-5.657M45.175 20.52a4 4 0 115.658 5.659 4 4 0 01-5.657-5.658M33.168 20.52a4 4 0 115.657 5.659 4 4 0 01-5.657-5.658M21.168 20.52a4 4 0 115.657 5.659 4 4 0 01-5.657-5.658M14.825 44.52a4 4 0 11-5.658 5.657 4 4 0 015.658-5.657"
//         fill="#2C2E2C"
//         fill-rule="nonzero"
//       />
//       <g transform="translate(44 43.35)">
//         <mask id="b" fill="#fff">
//           <use href="#a" />
//         </mask>
//         <path
//           d="M1.175 1.172a4 4 0 115.657 5.657 4 4 0 01-5.657-5.657"
//           fill="#2C2E2C"
//           fill-rule="nonzero"
//           mask="url(#b)"
//         />
//       </g>
//       <g transform="translate(31 43.35)">
//         <mask id="d" fill="#fff">
//           <use href="#c" />
//         </mask>
//         <path
//           d="M2.168 1.172a4 4 0 115.657 5.657 4 4 0 01-5.657-5.657"
//           fill="#2C2E2C"
//           fill-rule="nonzero"
//           mask="url(#d)"
//         />
//       </g>
//       <g transform="translate(19 43.35)">
//         <mask id="f" fill="#fff">
//           <use href="#e" />
//         </mask>
//         <path
//           d="M2.168 1.172a4 4 0 115.657 5.657 4 4 0 01-5.657-5.657"
//           fill="#2C2E2C"
//           fill-rule="nonzero"
//           mask="url(#f)"
//         />
//       </g>
//     </g>
//   </svg>
// );
// export const UShapedLayout = ({
//   width = defaultWidth,
//   fill = defaultColour
// }) => (
//   <svg
//     title={"U-shaped Layout"}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 64 64"
//     width={width}
//     fill={fill}
//   >
//     <g fill="#2C2E2C" fill-rule="nonzero">
//       <path d="M6 26a4 4 0 110 8 4 4 0 010-8M54 26a4 4 0 110 8 4 4 0 010-8M6 38a4 4 0 110 8 4 4 0 010-8M54 38a4 4 0 110 8 4 4 0 010-8M42 10a4 4 0 110 8 4 4 0 010-8M30 10a4 4 0 110 8 4 4 0 010-8M18 10a4 4 0 110 8 4 4 0 010-8M15 49.1h30a2 2 0 002-2v-24a2 2 0 00-2-2H15a2 2 0 00-2 2v24a2 2 0 002 2z" />
//     </g>
//   </svg>
// );
// export const ClassroomLayout = ({
//   width = defaultWidth,
//   fill = defaultColour
// }) => (
//   <svg
//     width={width}
//     title={"ClassroomLayout"}
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 64 64"
//     fill={fill}
//   >
//     <defs>
//       <path id="a" d="M0 8.159h8v8H0z" />
//       <path id="b" d="M0 20.159h8v8H0z" />
//       <path id="c" d="M0 32.165h8v8H0z" />
//       <path id="d" d="M0 44.16h8v8H0z" />
//       <path id="e" d="M36.008 44.16h8v8h-8z" />
//       <path id="f" d="M24 44.16h8v8h-8z" />
//       <path id="g" d="M12 44.16h8v8h-8z" />
//     </defs>
//     <g fill="none" fill-rule="evenodd">
//       <path
//         d="M14.829 13.33a4 4 0 11-5.658 5.657 4 4 0 015.658-5.657M14.829 25.33a4 4 0 11-5.658 5.657 4 4 0 015.658-5.657M14.829 37.337a4 4 0 11-5.658 5.657 4 4 0 015.658-5.657M14.829 49.33a4 4 0 11-5.658 5.658 4 4 0 015.658-5.657M45.18 49.332a4 4 0 115.657 5.657 4 4 0 01-5.658-5.657M33.172 49.332a4 4 0 115.657 5.657 4 4 0 01-5.657-5.657M21.172 49.332a4 4 0 115.657 5.657 4 4 0 01-5.657-5.657M45.18 13.331a4 4 0 115.657 5.658 4 4 0 01-5.658-5.658M33.172 13.331a4 4 0 115.657 5.658 4 4 0 01-5.657-5.658M21.172 13.331a4 4 0 115.657 5.658 4 4 0 01-5.657-5.658M45.18 25.331a4 4 0 115.657 5.658 4 4 0 01-5.658-5.658M33.172 25.331a4 4 0 115.657 5.658 4 4 0 01-5.657-5.658M21.172 25.331a4 4 0 115.657 5.658 4 4 0 01-5.657-5.658M45.18 37.337a4 4 0 115.657 5.658 4 4 0 01-5.658-5.657M33.172 37.337a4 4 0 115.657 5.658 4 4 0 01-5.657-5.657M21.172 37.337a4 4 0 115.657 5.658 4 4 0 01-5.657-5.657M12.004 8.165H48a2 2 0 002-2V6a2 2 0 00-2-2H12.004a2 2 0 00-2 2v.165a2 2 0 002 2z"
//         fill="#2C2E2C"
//         fill-rule="nonzero"
//       />
//     </g>
//   </svg>
// );


exports.UShapedLayout = UShapedLayout;